import {I18nProvider, Refine} from '@refinedev/core';
import {DevtoolsPanel, DevtoolsProvider} from '@refinedev/devtools';
import {RefineKbar, RefineKbarProvider} from '@refinedev/kbar';
import {RefineSnackbarProvider, useNotificationProvider} from '@refinedev/mui';
import routerProvider from '@refinedev/react-router';
import {useTranslation} from 'react-i18next';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router';

import {store} from '@app/store/store';
import {restDataProvider, treeQLDataProvider} from '@providers/data-provider';
import {DocumentTitleHandler} from '@providers/document-title/document-title-handler';
import {PromptProvider, UnsavedChangesNotifier} from '@providers/notification';
import {Routes} from '@providers/routes';
import {accessControlProvider} from '@providers/security/access-control-provider';
import {authProvider} from '@providers/security/auth-provider';
import {resources} from '@workspaces/resources';

const API_URL = import.meta.env.VITE_API_URL;

function App() {
  const {t, i18n} = useTranslation();

  const i18nProvider: I18nProvider = {
    // @ts-ignore
    translate: (key: string | string[], options?: object, defaultMessage?: string) => t(key, options, defaultMessage),
    changeLocale: (lang: string) => i18n.changeLanguage(lang),
    getLocale: () => i18n.language,
  };

  return (
    <BrowserRouter>
      <RefineKbarProvider>
        <RefineSnackbarProvider>
          <DevtoolsProvider>
            <PromptProvider>
              <Provider store={store}>
                <Refine
                  dataProvider={{
                    default: restDataProvider(API_URL),
                    treeQL: treeQLDataProvider(API_URL),
                  }}
                  notificationProvider={useNotificationProvider}
                  routerProvider={routerProvider}
                  authProvider={authProvider}
                  accessControlProvider={accessControlProvider}
                  i18nProvider={i18nProvider}
                  options={{
                    syncWithLocation: true,
                    warnWhenUnsavedChanges: true,
                    useNewQueryKeys: true,
                    projectId: 'Aysync-4AwYvx-Yov15C',
                  }}
                  resources={resources}
                >
                  <Routes />
                  <RefineKbar />
                  <UnsavedChangesNotifier />
                  <DocumentTitleHandler />
                </Refine>
              </Provider>
            </PromptProvider>
            <DevtoolsPanel />
          </DevtoolsProvider>
        </RefineSnackbarProvider>
      </RefineKbarProvider>
    </BrowserRouter>
  );
}

export default App;
